import { useEffect, useRef } from 'react';

/**
 * « Un envoi programmé a pu bouger » — a signal, not data (same pattern as missionsChanged).
 * Scheduling from the composer, cancelling or rescheduling from the banner: the thread banner,
 * the « Programmés » count and the draft lists each re-read THEIR server source.
 */
export const SCHEDULED_CHANGED_EVENT = 'mail-scheduled:changed';

export function notifyScheduledChanged(): void {
  window.dispatchEvent(new Event(SCHEDULED_CHANGED_EVENT));
}

/** Calls `onChange` on every signal; the last rendered callback is always the one called. */
export function useOnScheduledChanged(onChange: () => void): void {
  const latest = useRef(onChange);
  useEffect(() => {
    latest.current = onChange;
  }, [onChange]);

  useEffect(() => {
    const handler = () => latest.current();
    window.addEventListener(SCHEDULED_CHANGED_EVENT, handler);
    return () => window.removeEventListener(SCHEDULED_CHANGED_EVENT, handler);
  }, []);
}
